<template>
  <div class="conclusion" @click="showExist = false">
    <i class="iconfont iconfanhui back" @click.stop="$router.back()">返回</i>
    <van-icon class="bars" name="bars" color="#3A75B4" size="0.175rem" @click.stop="showExist = !showExist"/>
    <SideBar :show="showExist"></SideBar>
    <div class="banner">
      <p class="name">心血管疾病综合风险值</p>
      <p class="score">{{ comprehensiveRisk }} 分</p>
      <p class="reference">同龄人参考值：{{ peerRefer }}分</p>
      <p class="reference">得分越低风险越低</p>
    </div>
    <div class="tips">
      {{ prompt }}
    </div>
    <div class="listBox">
      <div class="list">
        <h1 class="title">综合健康管理建议：</h1>
        <div class="advice">
          <p class="advice_title">健管建议</p>
          <p class="word">{{ advice.healthAdvice}}</p>
        </div>
        <div class="advice">
          <p class="advice_title">体检建议</p>
          <p class="word">{{ advice.examinationAdvice}}</p>
        </div>
      </div>
    </div>
    <div class="listBox disease">
      <div class="list">
        <div>
          <h1 class="title">重点关注的疾病：</h1>
          <div class="notDisease" v-if="focusDiseases.length === 0">您暂时没有重点关注的疾病</div>
          <div v-else>
            <div class="item" v-for="(item, index) in focusDiseases" :key="index" :style="{ background: colors[index]}">{{ item }}</div>
          </div>
        </div>
        <div class="proper">
          <h1 class="title">适当关注的疾病：</h1>
          <div class="notDisease" v-if="appropriateDiseases.length === 0">您暂时没有适当关注的疾病</div>
          <div v-else>
            <div class="item" v-for="(item, index) in appropriateDiseases" :key="index" :style="{ background: colors1[index]}">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="listBox">
      <p class="more" @click="$router.push({path: '/riskFactors'})">*查看心血管疾病危险因素 <van-icon class="arrow" name="play" color="#2A6BAE"/></p>
      <p class="footer">
        整合多组学数据综合评价心血管疾病风险，
        只为给您提供更多、更精准的服务。
      </p>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBarResults.vue'
export default {
  name: 'index',
  data () {
    return {
      showExist: false,
      comprehensiveRisk: '',
      peerRefer: '',
      prompt: '',
      focusDiseases: [],
      appropriateDiseases: [],
      advice: {
        healthAdvice: '',
        examinationAdvice: ''
      },
      colors: ['#84CCC9', '#7ECEF4', '#88ABDA', '#FACD89', '#fc9075', '#F29C9F', '#8F82BC', '#89C997', '#C78FBE', '#63A1DA', '#99D884', '#F5A86E', '#D67EC8'],
      colors1: ['#63A1DA', '#99D884', '#F5A86E', '#D67EC8', '#84CCC9', '#7ECEF4', '#88ABDA', '#FACD89', '#F29C9F', '#8F82BC', '#89C997', '#C78FBE', '#fc9075']
    }
  },
  components: {
    SideBar
  },
  methods: {
    getConclusion () {
      this.util.get(this.api.conclusion, '', (success) => {
        this.comprehensiveRisk = success.data.comprehensiveRisk
        this.peerRefer = success.data.peerRefer
        this.prompt = success.data.prompt
        this.focusDiseases = success.data.focusDiseases
        this.appropriateDiseases = success.data.appropriateDiseases
        this.advice = success.data.advice
      })
    }
  },
  mounted () {
    this.getConclusion()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .conclusion {
    width: 100%;
    background: #fff;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .bars {
      position: absolute;
      top: pxToRem(20px);
      right: pxToRem(30px);
    }

    .banner {
      display: inline-block;
      width: 100%;
      height: pxToRem(472px);
      background: url('../../assets/images/ceramide/conclusionBg.png') no-repeat center;
      background-size: 100% 100%;
      text-align: center;

      .name {
        font-size: pxToRem(50px);
        font-weight: 500;
        color: #fff;
        line-height: pxToRem(63px);
        background: linear-gradient(-38deg,rgba(255,254,255,1) 0%, rgba(215,255,254,1) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-top: pxToRem(120px);
        letter-spacing: 1px;
      }

      .score {
        font-size: pxToRem(56px);
        font-weight: 500;
        color: #FFDE00;
        margin: pxToRem(58px) 0 pxToRem(43px);
      }

      .reference {
        font-size: pxToRem(14px);
        font-weight: 300;
        color: #fff;
        line-height: pxToRem(28px);
        letter-spacing: 1px;
      }
    }

    .tips {
      font-size: pxToRem(20px);
      font-weight: 400;
      color: #595757;
      padding: pxToRem(37px) pxToRem(69px);
      text-indent: 1em;
    }

    .listBox {
      padding: 0 pxToRem(36px);
      margin-bottom: pxToRem(35px);

      .list {
        background: #C4E3FE;
        border-radius: pxToRem(30px);
        padding: pxToRem(36px) pxToRem(45px);
        box-shadow:0px 4px 32px 0px rgba(192, 192, 192, 0.35);
      }

      .title {
        font-size: pxToRem(36px);
        font-weight: bold;
        color: #2A6BAE;
        line-height: pxToRem(44px);
        background: linear-gradient(85deg,rgba(4,192,226,1) 0%, rgba(28,145,226,1) 50%, rgba(88,101,185,1) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        margin-bottom: pxToRem(34px);
      }

      .advice {
        margin-bottom: pxToRem(22px);

        .advice_title {
          font-size: pxToRem(31px);
          font-weight: 400;
          color: #2A6BAE;
          line-height: pxToRem(44px);
          letter-spacing: 2px;
          margin-bottom: pxToRem(10px);
        }

        .word {
          font-size: pxToRem(20px);
          font-weight: 300;
          color: #595757;
          text-indent: 1em;
          text-align: justify;
        }
      }
    }

    .disease {

      .title {
        background: linear-gradient(85deg,rgba(253,126,94,1) 0%, rgba(255,15,71,1) 100%);
        -webkit-background-clip: text;
      }

      .item {
        width: 90%;
        background: #84CCC9;
        border-radius: pxToRem(10px);
        font-size: pxToRem(25px);
        font-weight: 400;
        color: #FFFEFE;
        text-align: center;
        margin: 0 auto;
        margin-bottom: pxToRem(6px);
        padding: pxToRem(14px) 0 pxToRem(9px);
        line-height: 1em;
      }

      .proper {
        margin: pxToRem(82px) 0 pxToRem(40px);

        .title {
          background:linear-gradient(85deg,rgba(16,213,185,1) 0%, rgba(32,156,255,1) 100%);
          -webkit-background-clip:text;
        }
      }

      .notDisease {
        width: 90%;
        background: #84CCC9;
        border-radius: pxToRem(10px);
        font-size: pxToRem(25px);
        font-weight: 400;
        color: #FFFEFE;
        text-align: center;
        margin: 0 auto;
        padding: pxToRem(14px) 0 pxToRem(9px);
        line-height: 1em;
      }
    }

    .more {
      font-size: pxToRem(22px);
      font-weight: 300;
      text-align: right;
      margin-bottom: pxToRem(28px);

      .arrow {
        margin-left: pxToRem(10px);
        vertical-align: middle;
      }
    }

    .footer {
      font-size: pxToRem(24px);
      font-weight: 400;
      color: #2A6BAE;
      margin: pxToRem(50px) pxToRem(80px) 0 pxToRem(75px);
      letter-spacing: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/conclusion/index.vue